import type {
  TeamTrainingResponse,
  TrainingItem,
  TrainingPersona,
  TrainingResponse,
} from "@/types/training";

import { requestData } from "@/api/api-config";

/** `catchError: false` on every call. */

export async function fetchTraining(): Promise<TrainingResponse> {
  return (await requestData<TrainingResponse>(
    "training",
    "get",
    undefined,
    false,
  )) as TrainingResponse;
}

export async function fetchTeamTraining(): Promise<TeamTrainingResponse> {
  return (await requestData<TeamTrainingResponse>(
    "training/team",
    "get",
    undefined,
    false,
  )) as TeamTrainingResponse;
}

async function postPlan(
  path: string,
  method: "post" | "put",
  json?: Record<string, unknown>,
): Promise<TrainingResponse> {
  return (await requestData<TrainingResponse>(
    path,
    method,
    json ? { json } : undefined,
    false,
  )) as TrainingResponse;
}

export const startTraining = (
  persona: TrainingPersona,
  extraPersonas: TrainingPersona[] = [],
) => postPlan("training/start", "post", { persona, extraPersonas });

export const changeTrainingPersona = (
  persona: TrainingPersona,
  extraPersonas: TrainingPersona[],
) => postPlan("training/persona", "put", { persona, extraPersonas });

export const setTrainingExtraPersonas = (extraPersonas: TrainingPersona[]) =>
  postPlan("training/extra-personas", "put", { extraPersonas });

export const restartTraining = () => postPlan("training/restart", "post");

export const completeTrainingTour = (tour: string) =>
  postPlan("training/tour-complete", "post", { tour });

type Transition = "complete" | "uncomplete" | "skip" | "unskip";

async function transition(
  itemId: string,
  action: Transition,
): Promise<TrainingItem> {
  return (await requestData<TrainingItem>(
    `training/items/${itemId}/${action}`,
    "post",
    undefined,
    false,
  )) as TrainingItem;
}

export const completeTrainingItem = (itemId: string) =>
  transition(itemId, "complete");
export const uncompleteTrainingItem = (itemId: string) =>
  transition(itemId, "uncomplete");
export const skipTrainingItem = (itemId: string) => transition(itemId, "skip");
export const unskipTrainingItem = (itemId: string) =>
  transition(itemId, "unskip");
